import { render, staticRenderFns } from "./content-data-report.vue?vue&type=template&id=6c60346e&scoped=true&"
import script from "./content-data-report.vue?vue&type=script&lang=js&"
export * from "./content-data-report.vue?vue&type=script&lang=js&"
import style0 from "./content-data-report.vue?vue&type=style&index=0&id=6c60346e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c60346e",
  null
  
)

component.options.__file = "content-data-report.vue"
export default component.exports